import { AlertTriangle } from "lucide-react";

export function DuplicateDialog({ duplicate, onResolve }) {
  if (!duplicate) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4" role="dialog" aria-modal="true" data-testid="duplicate-dialog">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 space-y-4">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" aria-hidden="true" />
          <div>
            <h2 className="text-base font-semibold text-slate-900">Questo documento sembra già presente.</h2>
            <p className="text-sm text-slate-600 mt-1">
              Un file identico ({duplicate.existing?.name}) è già nel Cassetto ESG. Come vuoi procedere?
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <button type="button" onClick={() => onResolve("new_version")}
            className="text-sm font-semibold text-white bg-green-700 hover:bg-green-800 rounded-md px-4 py-2 transition-colors"
            data-testid="duplicate-new-version">
            Carica come nuova versione
          </button>
          <button type="button" onClick={() => onResolve("link")}
            className="text-sm font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-100 rounded-md px-4 py-2 transition-colors"
            data-testid="duplicate-link">
            Collega comunque
          </button>
          <button type="button" onClick={() => onResolve("cancel")}
            className="text-sm font-semibold text-slate-500 hover:text-slate-700 px-4 py-2"
            data-testid="duplicate-cancel">
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
}
